<template>
    <span class="book-user-state-badge" :data-status="presentation.status">
        <i v-if="presentation.icon" class="fas" :class="`fa-${presentation.icon}`" aria-hidden="true"></i>
        <span>{{ presentation.label }}</span>
    </span>
</template>

<script>
import { bookStatusPresentation } from '../../utils/bookStatusPresentation';

export default {
    name: 'BookUserStateBadge',
    props: { status: { type: String, default: null } },
    computed: {
        presentation() {
            return bookStatusPresentation(this.status);
        },
    },
};
</script>

<style scoped>
.book-user-state-badge {
    display: inline-flex;
    align-items: center;
    gap: 0.4rem;
    max-width: 100%;
    border: 1px solid rgb(var(--foxy-border));
    border-radius: 9999px;
    padding: 0.3rem 0.65rem;
    background: rgb(var(--foxy-surface) / 0.88);
    color: rgb(var(--foxy-text-secondary));
    font-size: 0.75rem;
    font-weight: 700;
    line-height: 1rem;
}
.book-user-state-badge[data-status='want_to_read'] {
    border-color: rgb(var(--foxy-status-want) / 0.42);
    background: rgb(var(--foxy-status-want) / 0.12);
    color: rgb(var(--foxy-status-want));
}
.book-user-state-badge[data-status='reading'] {
    border-color: rgb(var(--foxy-status-reading) / 0.42);
    background: rgb(var(--foxy-status-reading) / 0.12);
    color: rgb(var(--foxy-status-reading));
}
.book-user-state-badge[data-status='read'] {
    border-color: rgb(var(--foxy-status-completed) / 0.42);
    background: rgb(var(--foxy-status-completed) / 0.12);
    color: rgb(var(--foxy-status-completed));
}
.book-user-state-badge[data-status='abandoned'] {
    border-color: rgb(var(--foxy-status-abandoned) / 0.42);
    background: rgb(var(--foxy-status-abandoned) / 0.12);
    color: rgb(var(--foxy-status-abandoned));
}
</style>
